import { schema } from 'normalizr';
import { MentorshipProgramProfileQuestion } from '../models/mentoring-program-profile-questions';

export const MentorshipProgramProfileQuestionSchema = new schema.Entity<MentorshipProgramProfileQuestion>('mentorshipProgramProfileQuestions');

export const MentorshipProgramProfileQuestionsSchema = new schema.Array(MentorshipProgramProfileQuestionSchema);
